import auth from "../middleware/auth";
import isStaff from "@/router/middleware/isStaff.js";

export default [
    {
        path: "/dashboard/parents/:type/:typeId",
        name: "parents",
        props: true,
        component: () => {
            return import(
                 "@/projects/parents/App.vue"
            );
        },
        children: [
            {
                path: "",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/parents/views/Parents.vue"
                        );
                    }
                }
            }
        ],
        meta: {
            middleware: [auth(false)]
        }
    },
    {
        path: "/dashboard/stats/:type/:typeId",
        name: "stats",
        props: true,
        component: () => {
            return import(
                 "@/projects/stats/App.vue"
            );
        },
        children: [
            {
                path: "homework",
                name: "homework",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/stats/views/Homework.vue"
                        );
                    }
                }
            },
            {
                path: "stars",
                name: "stars",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/stats/views/Stars.vue"
                        );
                    }
                }
            },
            {
                path: "files",
                name: "files",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/stats/views/Files.vue"
                        );
                    }
                }
            },
            {
                path: "logins",
                name: "logins",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/stats/views/Logins.vue"
                        );
                    }
                }
            },
            {
                path: "messages",
                name: "messages",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/stats/views/Messages.vue"
                        );
                    }
                }
            }
        ],
        meta: {
            middleware: [auth(false)]
        }
    },
    {
        path: "/dashboard/sync",
        name: "syncs.identities",
        component: () => {
            return import(
                 "@/projects/provider_settings/App.vue"
            );
        },
        middleware: [auth(false), isStaff],
        meta: {
            title: "accountsettings.list.title"
        },
        children: [
            {
                path: "",
                name: "provider-settings.list",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/provider_settings/views/General.vue"
                        );
                    }
                },
                meta: {
                    title: "accountsettings.list.title"
                }
            },
            {
                path: ":idp",
                name: "provider-settings.provider",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/provider_settings/views/Provider.vue"
                        );
                    }
                },
                meta: {
                    title: "accountsettings.msft.title"
                }
            }
        ]
    }
];
